import React from 'react';
import { Link } from 'react-router-dom';

export const Employess = () => {
    return (
        <div style={styles.Emp}>
            <h1 style={styles.text}>Employess</h1>
            <h2 style={styles.back}>
               <Link to="/">Back Home</Link>
            </h2>
        </div>
    )
}

const styles = {
    Emp: {
        width: "1000px",
        height: "500px",
        backgroundRepeat: "no-repeat",
        marginLeft: " 250px ",
        backgroundImage: "url(https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80)",
    },
    text: {
        textAlign: "center",
        
    },
    back: {
        textAlign: "center",
        margin: "100px",
        
    }
}